import React, { useState } from 'react';
import { Box, SxProps } from '@mui/material';
import { useContext } from 'react';
import { UiContext } from 'shared/lib/contexts/uiContext';

export const GridRowContext = React.createContext({
  isHover: false,
});

export default function GridRowContainer({
  onClick,
  children,
  className,
  sx,
  hardOverrideSx,
}: {
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  sx?: SxProps;
  hardOverrideSx?: SxProps;
}) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  const [isHover, setIsHover] = useState(false);

  return (
    <Box
      onClick={onClick}
      className={className}
      sx={
        hardOverrideSx || {
          'display': 'contents',
          'border': 'none',
          'cursor': onClick ? 'pointer' : 'unset',
          'borderBottom': 1,
          'borderColor': 'custom.borders',
          ...sx,
          '& > *': {
            px: sp.s50,
            borderBottom: 'inherit',
            py: sp.s40,
            // @ts-ignore
            ...sx?.['& > *'],
          },
          '& > *:first-of-type': {
            pl: 0,
            // @ts-ignore
            ...sx?.['& > *:first-of-type'],
          },
          '& > *:last-of-type': {
            pr: 0,
            // @ts-ignore
            ...sx?.['& > *:last-of-type'],
          },
        }
      }
      onMouseEnter={() => {
        setIsHover(true);
      }}
      onMouseLeave={() => {
        setIsHover(false);
      }}
    >
      <GridRowContext.Provider value={{ isHover }}>
        {children}
      </GridRowContext.Provider>
    </Box>
  );
}
